import { render, staticRenderFns } from "./EditBaseMailSkin.vue?vue&type=template&id=7ad06eb6&"
import script from "./EditBaseMailSkin.vue?vue&type=script&lang=ts&"
export * from "./EditBaseMailSkin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
